import React from 'react';
import { REPORT_TYPES } from '../../constants/reportTypes';

const ReportHistory = ({ reportHistory, onReportSelect }) => {
    if (reportHistory.length === 0) return null;

    return (
        <div className="report-history-section">
            <div className="consultation-types">
                <h3>📜 Your Previous Reports</h3>
                <div className="types-grid">
                    {reportHistory.map((report) => {
                        // ✅ Use correct field name: report_type (not reporttype)
                        const reportTypeInfo = REPORT_TYPES[report.report_type];

                        return (
                            <div 
                                key={report.id} 
                                className="consultation-card"
                                onClick={() => onReportSelect(report.id)}
                            >
                                <div>
                                    <h4 className="consult-name display-flex">
                                        <span className="service-icon">
                                            {reportTypeInfo?.icon || '📄'}
                                        </span>
                                        {/* ✅ Use correct field name: report_name (not reportname) */}
                                        {report.report_name}
                                    </h4>
                                    <p className="consult-details">
                                        <span className="consult-duration">
                                            {/* ✅ Use correct field name: created_at (not createdat) */}
                                            {new Date(report.created_at).toLocaleDateString('en-IN', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric'
                                            })}
                                        </span>
                                        <span className="separator">•</span>
                                        <span className="consult-price" style={{ color: '#4CAF50' }}>
                                            ✓ Cached
                                        </span>
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ReportHistory;
